import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

class RedoButton extends Component {
  _handleRedo = () => {
    // Below Code is being used for updating the
    // current active text editor data before doing Redo
    // const { section } = this.props;
    // if (section && section.type === "HTML") {
    //   const secElement = document.getElementById(
    //     `edit_editor_id_${section.id}`,
    //   );
    //   if (secElement) {
    //     secElement.focus();
    //   }
    // }
    this.props.handleRedo(this.props.mode);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };

  render() {
    return (
      <div
        className="draft-edit-items"
        id="toolbar-redo-button"
        key="toolbar-redo-button">
        <div className="draftJsToolbar__buttonWrapper__1Dmqh">
          <Tooltip
            placement="top"
            overlay="Redo"
            align={{
              offset: [3, 0],
            }}>
            <button
              type="button"
              className="redo-button toolbar-btn"
              data-test="toolbar-redo-button"
              onMouseDown={this._handleRedo}>
              <i>
                <FontAwesomeIcon icon={["far", "redo"]} />
              </i>
            </button>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default RedoButton;
